import userStore from "../store/userStore";

export const isUserAuthenticated = () => {
  return localStorage.getItem("token") || userStore?.token;
};
